import * as nodeUtils from "../../../../utils/nodeUtils";
import { moveFunctionFlat } from "../moveFunctionFlat";

export const moveFunctionAdapter = (root, id, idDestination) => {
  if (!idDestination) {
    return moveToBottom(root, id, idDestination);
  } else {
    return moveToTarget(root, id, idDestination);
  }
};

const moveToBottom = (root, id) => {
  const _functions = nodeUtils.getFunctions(root);

  return moveFunctionFlat(root, id, _functions.length - 1);
};

const moveToTarget = (root, id, idTarget) => {
  const _functions = nodeUtils.getFunctions(root);

  let _indexTarget;
  for (let i = 0; i < _functions.length; i++) {
    if (_functions[i].id === idTarget) {
      _indexTarget = i;
      break;
    }
  }
  let _indexDragged;
  for (let i = 0; i < _functions.length; i++) {
    if (_functions[i].id === id) {
      _indexDragged = i;
      break;
    }
  }

  return moveFunctionFlat(root, id, _indexTarget > _indexDragged ? _indexTarget - 1 : _indexTarget);
};
